define('Responsive/adapters/PanelAdapter',['require','exports','module','../util/dom','../vendor'],function(require,exports,module){
	var ReDom = require( '../util/dom' ),
        ReVendor = require( '../vendor' );

	var doc=document,
        classNameBase="ScrollPanelView",
        _noop=function(){},
        undef;
        
    function Panel(spv, view, position){
        var that=this;

        this.elClass=classNameBase+"-holder";
        this.parent=spv;
        this.view=view;
        this.id=view.id||view.name;
        this.active=false;
        this.viewController=view.viewController;
        this.el=doc.createElement('div');
        //this.holder=document.createDocumentFragment();
        this.width='100%';        
        this.el.setAttribute('data-view-id',this.id);
        this.el.className=this.elClass;

        if(spv.nav){
            this.nav=doc.createElement('li');
            this.nav.innerHTML=view.name;
            this.nav.setAttribute('data-view-id',this.id);
            if (position === undefined) {
            	this.parent.nav.appendChild(this.nav);
            } else {
            	this.parent.nav.replaceChild(this.nav, this.parent.nav.childNodes[position]);
            }
            
            this.setNav=function(active){
                if(that.parent.focus === view.index || active) {
                    ReDom.setClassName(that.nav, "active");
                } else {
                    ReDom.removeClassName(that.nav, "active");
                }
            };
            this.setNavTitle=function(title){
                that.nav.innerHTML=title;
            };            
            this.setData=function(prop,val){
                that.nav.setAttribute('data-'+prop,val);
            };
            function panelTap(e){
                e.preventDefault();
                that.parent.slots[that.parent.focus].setNav(false);
                that.setNav(true);
                that.parent.uiDelegate.scrollTo(that.view.index, that.parent.focus);
                return false;
            }
            this.nav.addEventListener("touchstart",panelTap,true,false);
            this.nav.addEventListener("mousedown",panelTap,true,false);
        } else {
            this.setNav=_noop;
        }
        
        if (position === undefined) {
        	this.parent.viewHolder.appendChild(this.el);
        } else {
        	this.parent.viewHolder.replaceChild(this.el, this.parent.viewHolder.childNodes[position]);
        }
        
        return this;
    }
    
    Panel.prototype.setWidthPercent=function(){
        var newWidth=100/this.parent.viewCount + '%';
        if(this.width!==newWidth){
            this.el.style.minWidth=this.el.style.width=this.width=newWidth;
            if(this.nav){
                this.nav.style.width=newWidth;
                this.nav.style.minWidth=newWidth;
            }
        }
    };

    Panel.prototype.setActiveClass=function(){
        if(this.parent.focus === this.view.index) {
            ReDom.setClassName(this.el, 'active');
        } else {
            ReDom.removeClassName(this.el, 'active');
        }
    };
    
    Panel.prototype.setActive=function(active,immediate){
        var that=this,
            render,
            holder,
            was=this.active;

        this.setNav();
        this.active=active;
        this.setActiveClass();

        if(active===false && was){
            this.deactivate();
        } else if(active && was!==true){
            this.activate();
        }
                
    };

    Panel.prototype.activate=function(){
        var frag=doc.createDocumentFragment();
        this.viewController.viewWillAppear();
        frag.appendChild(this.viewController.getView());
        this.el.appendChild(frag);
        this.viewController.viewDidAppear();
    };

    Panel.prototype.deactivate=function(){
        this.viewController.viewWillDisappear();
        ReDom.removeNode(this.el,this.viewController.getView());
        this.viewController.viewDidDisappear();
    };

    Panel.prototype.destroy=function(){
        this.setActive(false,true);
        this.viewController.viewDidUnload.call(this.viewController);
        this.el=null;
        this.nav=null;
    };

	return Panel;
});
